export default __webpack_public_path__ + "static/media/list-view.inline.b31bfd57.svg";